module.exports = {XMLHttpRequest:XMLHttpRequest};


//////////////////
// WEBPACK FOOTER
// external "{XMLHttpRequest:XMLHttpRequest}"
// module id = 803
// module chunks = 2